<template>
  <div class="main">
    <Header 
      :show="true"
      title="办公道闸"
      left="prepage" 
      right="" 
      :click-left="handleClickLeft" 
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
      <van-notice-bar
        wrapable
        :scrollable="false"
        left-icon="info-o"
        text="通过人工进行干预，请谨慎修改"
      />
      <van-form>
        <van-field 
          label="是否设置道闸全开"
          name="是否设置道闸全开" 
          required
        >
          <template #input>
            <van-switch 
              size="20" 
              :value="listQuery.way.old === 1 ? false : true"
              @input="checkPermission([322]) === true ? handleInputSwitch() : null"
            />
          </template>
        </van-field>
        <van-field
          v-model="listQuery.all.old"
          label="道闸全开时长(秒)"
          :placeholder="listQuery.all.old+'秒'"
          input-align="right"
          required
          @click="dialogVisibleUpdateAll = true"
        />
        <van-field
          v-model="listQuery.half.old"
          label="道闸半开时长(秒)"
          :placeholder="listQuery.half.old+'秒'"
          input-align="right"
          required
          @click="dialogVisibleUpdateHalf = true"
        />
      </van-form>
      
      <van-dialog
        v-model="dialogVisibleUpdateAll" 
        title="全开开闸时长设置"
        show-cancel-button
        :before-close="handleClickUpdateAllConfirm"
      >
        <van-field
          v-model.trim="listQuery.all.old"
          label="当前时长"
          placeholder="请输入正确当前值"
          required
          readonly
        />
        <van-field
          v-model.trim="listQuery.all.new"
          label="设定时长"
          placeholder="请输入正确设定值"
          required
        />
      </van-dialog>
      
      <van-dialog
        v-model="dialogVisibleUpdateHalf" 
        title="半开开闸时长设置"
        show-cancel-button
        :before-close="handleClickUpdateHalfConfirm"
      >
        <van-field
          v-model.trim="listQuery.half.old"
          label="当前时长"
          placeholder="请输入正确当前值"
          required
          readonly
        />
        <van-field
          v-model.trim="listQuery.half.new"
          label="设定时长"
          placeholder="请输入正确设定值"
          required
        />
      </van-dialog>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>

  import { Dialog } from 'vant'
  import { showPhoneAlarm } from '@/global/function.js'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { getList, updateOne } from '@/api/switch.js'

  export default {
    name: "ServiceProjectSwitch",
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      return {
        isLoading: false,
        dialogVisibleUpdate: false,
        loading: false,
        table: {
          listLoading: false,
          height: document.documentElement.clientHeight-340,
          key: 0,
          total: 0,
          data: []
        },
        listQuery: {
          page: 1,
          limit: 10,
          way: {
            id: null,
            old: 1,
            new: 1
          },
          all: {
            id: null,
            name: '全开开闸时长设置',
            old: 0,
            new: 0,
            unit: '秒'
          },
          half: {
            id: null,
            name: '半开开闸时长设置',
            old: 0,
            new: 0,
            unit: '秒'
          }
        }
      }
    },
    computed: {

    },
    watch: {
      
    },
    beforeCreate() {
      
    },
    created() {
      this.handleClickQuery()
    },
    beforeMount() {
      
    },
    mounted() {
      
    },
    beforeUpdate() {
      
    },
    updated() {
      
    },
    beforeDestroy() {
      
    },
    destroyed() {
      
    },
    methods: {
      checkPermission,
      handleClickLeft() {
        this.$router.go(-1)
        // console.log('dashboard-left')
      },
      handleClickRight() {
        this.$router.push({ 
          path:'/service/system/staff/create', 
          query: {} ,
        })
      },
      handleClickQuery() {
        const data = {}
        getList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            const items = data.data
            this.table.data = []
            for (let i=0; i<items.length; i++) {
              if (items[i].name === '办公区道闸开闸方式') {
                this.listQuery.way.id = items[i].id
                this.listQuery.way.old = parseInt(items[i].value)
              } else if (items[i].name === '办公区道闸半开时长') {
                this.listQuery.half.id = items[i].id
                this.listQuery.half.old = items[i].value
              } else if (items[i].name === '办公区道闸全开时长') {
                this.listQuery.all.id = items[i].id
                this.listQuery.all.old = items[i].value
              }
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      handleInputSwitch() {
        let message = '是否设置道闸开启方式为半开?'
        if (this.listQuery.way.old === 1) {
          message = '是否设置道闸开启方式为全开?'
        }
        Dialog.confirm({
          title: '提醒',
          message: message,
        }).then(() => {
          if (this.listQuery.way.old === 1) {
            this.listQuery.way.new = 2
          } else {
            this.listQuery.way.new = 1
          }
          const data = {
            id: this.listQuery.way.id,
            value: this.listQuery.way.new
          }
          this.loading = true
          updateOne(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '设置道闸开启方式', data.message)) {
              this.handleClickQuery()
            }
            this.loading = false
          }).catch(function(error) {
            this.loading = false
            console.error(error)
          })
        })
      },
      handleClickUpdateAllConfirm() {
        Dialog.confirm({
          title: '提醒',
          message: '确定将道闸全开时长修改为：'+this.listQuery.all.new+'秒',
        }).then(() => {
          const data = {
            id: this.listQuery.all.id,
            value: this.listQuery.all.new
          }
          this.loading = true
          updateOne(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '道闸全开时长', data.message)) {
              this.handleClickQuery()
            }
            this.loading = false
          }).catch(function(error) {
            this.loading = false
            console.error(error)
          })
        })
        this.dialogVisibleUpdateAll = false
      },
      handleClickUpdateHalfConfirm() {
        Dialog.confirm({
          title: '提醒',
          message: '确定将道闸半开时长修改为：'+this.listQuery.half.new+'秒',
        }).then(() => {
          const data = {
            id: this.listQuery.half.id,
            value: this.listQuery.half.new
          }
          this.loading = true
          updateOne(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '道闸半开时长', data.message)) {
              this.handleClickQuery()
            }
            this.loading = false
          }).catch(function(error) {
            this.loading = false
            console.error(error)
          })
        })
        this.dialogVisibleUpdateHalf = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  // 系统样式修改
  ::v-deep .van-cell__title {
    max-width: 100%;
  }
  ::v-deep .van-field__label {
    width: 80%;
  }
  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F7F8FA; 
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex; 
    // justify-content: center; 
    // align-items: center;
  }
</style>
